/**
 * Generates the GA4 `_gl` linker parameter and appends it to `url`.
 *
 * Must be called JUST BEFORE navigation — `_gl` contains a time-based fingerprint
 * hash with a ~2 min TTL, so it cannot be cached or pre-generated at render time.
 *
 * Use only for JS-driven cross-domain redirects (`window.location.href = ...`)
 * or OAuth flows where gtag auto-decoration won't kick in. For regular
 * `<a href>` clicks, gtag's linker config handles `_gl` automatically.
 */
export const decorateUrlWithGaLinker = (url: string): string => {
    if (typeof window === "undefined") {
        return url;
    }

    try {
        const gl = buildGaLinkerParam();
        if (!gl) {
            console.warn("[ga-linker] empty _gl / _ga / _ga_<MID> / FPLC");
            return url;
        }
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set("_gl", gl);
        return parsed.toString();
    } catch (err) {
        console.warn("[ga-linker] _gl:", err);
        return url;
    }
};

const buildGaLinkerParam = (): string | null => {
    const encodedCookies = document.cookie
        .split("; ")
        .map(parseCookie)
        .filter((cookie): cookie is [string, string] => cookie != null)
        .filter(([name]) => isSupportedGaCookie(name))
        .map(([name, value]) => encodeGaCookie(name, value))
        .filter((cookie): cookie is string => cookie != null);

    if (encodedCookies.length === 0) {
        return null;
    }

    return ["1", getFingerPrint(encodedCookies), encodedCookies.join("*")].join("*");
};

const parseCookie = (cookie: string): [string, string] | null => {
    const separatorIndex = cookie.indexOf("=");
    if (separatorIndex === -1) {
        return null;
    }

    return [cookie.slice(0, separatorIndex), cookie.slice(separatorIndex + 1)];
};

const isSupportedGaCookie = (name: string): boolean => /^_ga(?:_[A-Z0-9]+)?$/.test(name) || name === "FPLC";

const encodeGaCookie = (name: string, value: string): string | null => {
    if (name === "FPLC") {
        return `_fplc*${encodeBase64(value)}`;
    }

    const normalizedValue = normalizeGaCookieValue(value);
    return normalizedValue ? `${name}*${encodeBase64(normalizedValue)}` : null;
};

const normalizeGaCookieValue = (value: string): string | null => {
    const match = value.match(/^G[A-Z]\d+\.\d+\.(.+)$/);
    return match?.[1] ?? null;
};

const encodeBase64 = (value: string): string => btoa(value).replace(/=/g, ".");

const getFingerPrint = (cookies: string[]): string => {
    const navigatorWithUserLanguage = window.navigator as Navigator & {userLanguage?: string};
    const fingerPrintString = [
        navigatorWithUserLanguage.userAgent,
        new Date().getTimezoneOffset(),
        navigatorWithUserLanguage.userLanguage || navigatorWithUserLanguage.language,
        Math.floor(new Date().getTime() / 60 / 1e3),
        cookies.join("*")
    ].join("*");

    const crcTable = Array.from({length: 256}, (_, index) => {
        let crc = index;

        for (let bitIndex = 0; bitIndex < 8; bitIndex += 1) {
            crc = crc & 1 ? 0xedb88320 ^ (crc >>> 1) : crc >>> 1;
        }

        return crc;
    });

    let crc = 0 ^ -1;
    for (let index = 0; index < fingerPrintString.length; index += 1) {
        crc = (crc >>> 8) ^ crcTable[(crc ^ fingerPrintString.charCodeAt(index)) & 0xff];
    }

    return ((crc ^ -1) >>> 0).toString(36);
};
/**
 * Generates the GA4 `_gl` linker parameter and appends it to `url`.
 *
 * Must be called JUST BEFORE navigation — `_gl` contains a time-based fingerprint
 * hash with a ~2 min TTL, so it cannot be cached or pre-generated at render time.
 *
 * Use only for JS-driven cross-domain redirects (`window.location.href = ...`)
 * or OAuth flows where gtag auto-decoration won't kick in. For regular
 * `<a href>` clicks, gtag's linker config handles `_gl` automatically.
 */
export const decorateUrlWithGaLinker = (url: string): string => {
    if (typeof window === "undefined") {
        return url;
    }

    try {
        const gl = buildGaLinkerParam();
        if (!gl) {
            console.warn("[ga-linker] empty _gl / _ga / _ga_<MID> / FPLC");
            return url;
        }
        const parsed = new URL(url, window.location.origin);
        parsed.searchParams.set("_gl", gl);
        return parsed.toString();
    } catch (err) {
        console.warn("[ga-linker] _gl:", err);
        return url;
    }
};

const buildGaLinkerParam = (): string | null => {
    const encodedCookies = document.cookie
        .split("; ")
        .map(parseCookie)
        .filter((cookie): cookie is [string, string] => cookie != null)
        .filter(([name]) => isSupportedGaCookie(name))
        .map(([name, value]) => encodeGaCookie(name, value))
        .filter((cookie): cookie is string => cookie != null);

    if (encodedCookies.length === 0) {
        return null;
    }

    return ["1", getFingerPrint(encodedCookies), encodedCookies.join("*")].join("*");
};

const parseCookie = (cookie: string): [string, string] | null => {
    const separatorIndex = cookie.indexOf("=");
    if (separatorIndex === -1) {
        return null;
    }

    return [cookie.slice(0, separatorIndex), cookie.slice(separatorIndex + 1)];
};

const isSupportedGaCookie = (name: string): boolean => /^_ga(?:_[A-Z0-9]+)?$/.test(name) || name === "FPLC";

const encodeGaCookie = (name: string, value: string): string | null => {
    if (name === "FPLC") {
        return `_fplc*${encodeBase64(value)}`;
    }

    const normalizedValue = normalizeGaCookieValue(value);
    return normalizedValue ? `${name}*${encodeBase64(normalizedValue)}` : null;
};

const normalizeGaCookieValue = (value: string): string | null => {
    const match = value.match(/^G[A-Z]\d+\.\d+\.(.+)$/);
    return match?.[1] ?? null;
};

const encodeBase64 = (value: string): string => btoa(value).replace(/=/g, ".");

const getFingerPrint = (cookies: string[]): string => {
    const navigatorWithUserLanguage = window.navigator as Navigator & {userLanguage?: string};
    const fingerPrintString = [
        navigatorWithUserLanguage.userAgent,
        new Date().getTimezoneOffset(),
        navigatorWithUserLanguage.userLanguage || navigatorWithUserLanguage.language,
        Math.floor(new Date().getTime() / 60 / 1e3),
        cookies.join("*")
    ].join("*");

    const crcTable = Array.from({length: 256}, (_, index) => {
        let crc = index;

        for (let bitIndex = 0; bitIndex < 8; bitIndex += 1) {
            crc = crc & 1 ? 0xedb88320 ^ (crc >>> 1) : crc >>> 1;
        }

        return crc;
    });

    let crc = 0 ^ -1;
    for (let index = 0; index < fingerPrintString.length; index += 1) {
        crc = (crc >>> 8) ^ crcTable[(crc ^ fingerPrintString.charCodeAt(index)) & 0xff];
    }

    return ((crc ^ -1) >>> 0).toString(36);
};
